import { useState } from 'react'

import { useToasts } from '@/hooks/useToasts'
import { useTranslation } from 'react-i18next'

import { useDisclosure } from '@chakra-ui/react'

import { useArchiveRuleMutation } from '@/graphql/generated/hooks'
import { tVar } from '@/utils/i18n'

import { RulesType } from '../utils/utils'

export const useRemoveRule = () => {
  const { t } = useTranslation()
  const [selectedRule, setSelectedRule] = useState<RulesType>(null)
  const { showSuccess, showError } = useToasts()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [archiveRule, { loading: isArchiveRuleLoading }] =
    useArchiveRuleMutation()

  const handleRemoveRule = async () => {
    try {
      await archiveRule({
        variables: {
          input: {
            id: selectedRule.id,
          },
        },
        refetchQueries: ['Rules'],
      })
      showSuccess(
        tVar(t, 'automations:table_archive_success', {
          name: selectedRule.name,
        })
      )
      onClose()
    } catch {
      showError()
    }
  }

  return {
    isArchiveRuleLoading,
    isOpen,
    selectedRule,
    handleRemoveRule,
    setSelectedRule,
    onOpen,
    onClose,
  }
}
